"use client"

import { useEffect } from "react"

/**
 * Global error handler for React errors
 * Logs detailed information about React errors to help debug production issues
 */
export function ReactErrorHandler() {
  useEffect(() => {
    // Capture unhandled React errors
    const errorHandler = (event: ErrorEvent) => {
      console.error("[ReactErrorHandler] Unhandled error:", {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
        stack: event.error?.stack,
      })
    }

    // Capture unhandled promise rejections
    const rejectionHandler = (event: PromiseRejectionEvent) => {
      console.error("[ReactErrorHandler] Unhandled promise rejection:", {
        reason: event.reason,
        promise: event.promise,
      })
    }

    window.addEventListener("error", errorHandler)
    window.addEventListener("unhandledrejection", rejectionHandler)

    return () => {
      window.removeEventListener("error", errorHandler)
      window.removeEventListener("unhandledrejection", rejectionHandler)
    }
  }, [])

  return null
}
